module.exports = __webpack_public_path__ + "static/media/medals.ac2deb00.jpg";